// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__38v7Y","img":"Landing_img__SmL7w","div":"Landing_div__3XQ8r","h1":"Landing_h1__38kU9","h2":"Landing_h2__2O6Td","button":"Landing_button__wyUxN"};